import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';

const reactotron = Reactotron.configure({ name: 'RTV web' }).use(
  reactotronRedux()
);

if (process.env.NODE_ENV !== 'production') Reactotron.connect();

export default reactotron;
